<template lang="pug">
  v-layout.box-main-mis-seguros-formatter
    v-flex(v-if="($vuetify.breakpoint.width < 1024)" )
      MisSegurosMobile(
        :infoPoliza="infoPoliza"
        :infoUser="infoUser"
        :action="action"
      )
    v-flex(v-if="($vuetify.breakpoint.width >= 1024)" )
      MisSegurosDesktop(
        :infoPoliza="infoPoliza"
        :infoUser="infoUser"
        :action="action"
      )
    v-flex.box-guia-mis-seguros(v-if="($vuetify.breakpoint.width >= 1200)" )
      GuiaMisSeguros.box-guia-seguros-formatter(
        :producto="infoPoliza.nombreProducto"
        :oriProducto="infoPoliza.oriProducto || ''"
      )

</template>

<script>
import MisSegurosMobile from './MisSegurosMobile.vue'
import MisSegurosDesktop from './MisSegurosDesktop.vue'
import GuiaMisSeguros from '@/components/mis-seguros/GuiaMisSeguros.vue'

export default {
  props: [
    'infoPoliza',
    'infoUser',
    'action'
  ],
  data () {
    return {
      userData: {},
      polizaData: {}
    }
  },
  mounted () {
    if ((this.infoPoliza.nombreProducto || '').includes('VIDACASH')) {
      setTimeout(() => { window.hj('event', 'ev-zs-misseguros-vida-cash') }, 3000)
    }
  },
  components: {
    MisSegurosMobile,
    MisSegurosDesktop,
    GuiaMisSeguros
  }
}
</script>

<style>
@media (min-width : 320px) {
  .box-monto-asegurado-formatter {
    width: 100%;
    background: #F1F1F1;
    border-radius: 9px;
    padding: 0.5em 0em;
  }

  .box-card-periodo-cuota-formatter {
    box-sizing: border-box !important;
  }

  .box-menu-mis-seguros .box-menu-formatter {
    padding: 0.4em 0;
    border-bottom: 1px solid #C4C4C4;
  }

  .box-menu-formatter .icon-flag {
    transition: all 350ms;
    transform: rotate(0deg);
  }

  .box-menu-formatter:focus-within .icon-flag {
    transform: rotate(90deg);
  }

  .box-menu-formatter .icon-rotate {
    transform: rotate(90deg);
  }
}

@media (min-width : 600px) {
  .box-mis-seguros-formatter {
    padding: 2.5em;
    border: 1px solid #e9e9e9;
    border-radius: 1em;
    box-shadow: 0px 0px 1px 0px;
    max-width: 35em;
    margin-top: 7em;
  }
}

@media (min-width : 960px) {
  .box-mis-seguros-formatter {
    margin-top: 8em;
  }
}

@media (min-width : 1024px) {
  .box-guia-mis-seguros {
    background-color: #ffffff;
    max-width: 300px;
    width: 330px;
    padding: 40px 25px;
  }

  .box-main-mis-seguros-formatter {
    height: calc(100vh - 61px) !important;
  }
}

@media (min-width: 1380px) {
  .box-guia-mis-seguros {
    max-width: 330px;
    padding: 40px !important;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/mis-seguros/MisSeguros.vue